// useProjectIssues — the issues of the project the Studio shows, for its
// Export button (PS-54). Shell-side: it asks the server whenever the project
// or the library changes (a part planned, written, reviewed or a proposal
// decided moves the count), and hands the answer to the Studio. A failed ask
// (offline) keeps the last answer, so the list still shows; another
// project's answer is never shown.

export { useProjectIssues };

import { Result } from "@bilda/utils";
import { useEffect, useState } from "react";
import type { ProjectIssues } from "../../ports/project.js";
import type { AppPorts, Library } from "../../ports.js";

type Answer = { readonly projectId: string; readonly issues: ProjectIssues };

const useProjectIssues = (
    ports: AppPorts,
    projectId: string | null,
    library: Library | null,
): ProjectIssues | undefined => {
    const [answer, setAnswer] = useState<Answer | undefined>(undefined);
    useEffect(() => {
        if (library === null || projectId === null) return;
        let current = true;
        const go = async () => {
            const r = await ports.loadProjectIssues(projectId);
            if (current && Result.isOk(r))
                setAnswer({ projectId, issues: r.value });
        };
        void go();
        return () => {
            current = false;
        };
    }, [ports, projectId, library]);
    return answer?.projectId === projectId ? answer.issues : undefined;
};
